import React, { useState } from 'react';
import { useAuth } from '../components/AuthContext';
import { passkeysBeschikbaar } from '../util/webauthn';

export default function Login() {
  const { login, loginMetPasskey } = useAuth();
  const [email, setEmail] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [bezig, setBezig] = useState(false);
  const [passkeyBezig, setPasskeyBezig] = useState(false);
  const [fout, setFout] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setFout(null);
    setBezig(true);
    try {
      await login(email.trim(), wachtwoord);
    } catch (err) {
      const status = err?.response?.status;
      setFout(status === 401 ? 'Onjuiste inloggegevens.' : 'Inloggen mislukt. Probeer het opnieuw.');
      setBezig(false);
    }
  };

  const passkeyLogin = async () => {
    setFout(null);
    setPasskeyBezig(true);
    try {
      await loginMetPasskey();
    } catch (err) {
      if (err?.name === 'NotAllowedError') {
        // gebruiker brak Touch ID/Face ID af — geen foutmelding nodig
      } else {
        setFout('Inloggen met passkey mislukt. Probeer het opnieuw of gebruik je wachtwoord.');
      }
      setPasskeyBezig(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 20,
    }}>
      <form
        onSubmit={submit}
        className="card"
        style={{ width: '100%', maxWidth: 380, display: 'flex', flexDirection: 'column' }}
      >
        <h1 style={{ fontSize: 24, fontWeight: 600, margin: 0, color: 'var(--text)' }}>
          Grondwaterregister
        </h1>
        <p style={{ margin: '2px 0 24px', color: 'var(--text-muted)', fontSize: 14 }}>
          Waterschap Brabantse Delta
        </p>

        {fout && <div className="alert alert-error" style={{ marginBottom: 14 }}>{fout}</div>}

        <label className="field-label" htmlFor="login-email" style={{ marginBottom: 6 }}>E-mail</label>
        <input
          id="login-email"
          name="username"
          className="input"
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label className="field-label" htmlFor="login-wachtwoord" style={{ marginTop: 14, marginBottom: 6 }}>Wachtwoord</label>
        <input
          id="login-wachtwoord"
          name="password"
          className="input"
          type="password"
          autoComplete="current-password"
          required
          value={wachtwoord}
          onChange={(e) => setWachtwoord(e.target.value)}
        />

        <button
          type="submit"
          className="btn btn-primary"
          disabled={bezig}
          style={{ marginTop: 20, width: '100%', justifyContent: 'center' }}
        >
          {bezig ? <><span className="spinner" /> Bezig met inloggen...</> : 'Inloggen'}
        </button>

        {passkeysBeschikbaar() && (
          <>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 12,
              margin: '18px 0 14px', color: 'var(--text-muted)', fontSize: 13,
            }}>
              <span style={{ flex: 1, height: 1, background: 'var(--border)' }} />
              of
              <span style={{ flex: 1, height: 1, background: 'var(--border)' }} />
            </div>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={passkeyLogin}
              disabled={passkeyBezig}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              {passkeyBezig ? <><span className="spinner" /> Even bevestigen...</> : 'Inloggen met passkey'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
